const MODULE = 'MAP_VIEW'
export const MAP_POSITION_UPDATED = `${MODULE}/MAP_POSITION_UPDATED`
export const SET_BOTTOM_LABEL = `${MODULE}/SET_BOTTOM_LABEL`
export const REMOVE_BOTTOM_LABEL = `${MODULE}/REMOVE_BOTTOM_LABEL`
export const MAP_RESET = `${MODULE}/RESET`
